export default __webpack_public_path__ + "static/media/fetters_of_the_dandelion_gladiator.3116c0fa.png";